define('shared/initializer/form/adapters/mixins/EventLoadedEmittable',[
    'shared/lib/RSVP'
], function(RSVP) {
    'use strict';
    
    function Ctor() { }

    Ctor.prototype.doPageLoad = function ()
    {   
        this.$form.attr('data-form-loaded', 'true');
        this.$form.trigger('form.loaded');
        return RSVP.resolve();
    };

    return Ctor;

});
